<template>
  <div
    class="aha-clipboard-input"
    @click="$emit('click')"
  >
    <span class="aha-clipboard-value">{{ value }}</span>
    <span class="aha-clipboard-button">
      <aha-icon
        :name="iconName"
        v-tooltip="tooltipText"
      />
    </span>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: null,
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-clipboard-input {
  @apply flex flex-row justify-between items-center;
  @apply appearance-none cursor-pointer mr-2;
  @apply py-2 pl-2 text-sm rounded border border-secondary-20 w-full;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply hover:bg-primary-20 hover:border-primary-90;
}
.aha-clipboard-value {
  @apply overflow-hidden overflow-ellipsis whitespace-nowrap;
}
.aha-clipboard-button {
  @apply mr-2 text-primary-90 font-bold;
}
</style>
